import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import ScheduleIcon from '@mui/icons-material//Schedule';
import { Box, Typography } from '@mui/material';
import { TaskContext } from 'context/TaskContext';
import { TaskContextType } from 'context/TaskContext/types';
import { formatExpirationDate, getExpirationDate } from 'pages/ProcessManagement/utils/expirationDate';
import TimeBlock from './TimeBlock';

const TaskExpirationDate = () => {
  const {
    task: { created_at: createdAt },
  } = useContext(TaskContext) as TaskContextType;
  const expirationDate = useMemo(() => getExpirationDate(createdAt), [createdAt]);
  const [formattedExpirationDate, setFormattedExpirationDate] = useState(formatExpirationDate(expirationDate));

  const updateFormattedDate = useCallback(() => {
    setFormattedExpirationDate(formatExpirationDate(expirationDate));
  }, [expirationDate]);

  useEffect(() => {
    const interval = setInterval(updateFormattedDate, 1000);
    return () => clearInterval(interval);
  }, [updateFormattedDate]);

  const [days, hours, minutes, seconds] = formattedExpirationDate.split(' ');

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box display="flex" alignItems="center" marginBottom="0.5rem">
        <ScheduleIcon style={{ marginRight: '0.5rem', color: '#8A9097', fontSize: '1rem' }} />
        <Typography style={{ fontSize: '1rem', fontWeight: 400, textTransform: 'uppercase', color: '#8A9097' }}>
          The requests expires in
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <TimeBlock value={days} label="days" />
        <TimeBlock value={hours} label="hours" />
        <TimeBlock value={minutes} label="minutes" />
        <TimeBlock value={seconds} label="seconds" />
      </Box>
    </Box>
  );
};

export default TaskExpirationDate;
